import React, { useContext, useEffect, useState } from "react";
import { Tabs, Tab, Nav, Modal, Button, Table, Form } from "react-bootstrap";
import settingw from "../../assets/setting-white.svg";
import docGrey from "../../assets/doc-grey.svg";
import downloadImg from "../../assets/download.svg";
import backImg from "../../assets/back.svg";
import deleteImageEnabled from "../../assets/reddelete.svg";
import { processType } from "../../utils/constant";
import { Modal as AntModal } from "antd";
import {
  handleDeclineRFQ,
  getRFQByRFQRefId,
  uploadRFQDocument,
  deleteRFQDocument,
  createOfferAcceptedPO,
  declineOffer,
  ReturnSubmitQuotations,
  getEightXAddress,
  downloadBatchFile,
  getRFQByRFQId,
} from "../../utils/actions/userActions";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  downloadFileFromS3,
  extractURLAndEncodedFilename,
  numberInputOnWheelPreventChange,
  validateUser,
} from "../../utils/helper";
import { toast } from "react-toastify";
import moment from "moment";

import { OrdersContext } from "../../context/orders.context";
import ChatButton from "../../component/Chat/ChatButton";
import Chat from "../../component/Chat";
import qs from "query-string";
import CurrencyFormat from "../../component/CurrencyFormat";
import { Loading } from "../../component/Loading";
import { DeleteIcon, DownloadIcon, LucidLoader } from "../../component/icons";
import MetaDataCncComponent from "../../component/MetaDataComponents/MetaDataCncComponent";
import MetaDataThreeDComponent from "../../component/MetaDataComponents/MetaDataThreeDComponent";
import { getAllMaterialsList, getAllTechnology, getPresignedUrlForFile } from "../../helperApi/helperApi";
import ThreeDViewerComponent from "../../component/ThreeDViewerComponent/ThreeDViewerComponent";
import FileName from "../../component/FileName";
import { ChatRefContext } from "../../context/chatRef.context";
import PDFModalViewer from "../../component/PDFViewerModal/PDFModalViewer";

const OfferDetails = () => {
  const loggedInUserToken = localStorage.getItem("Token");
  const [isValidUser, setIsValidUser] = useState(true);
  const [selectedRFQ, setSelectedRFQ] = useState({});
  const [showDeclineModal, setShowDeclineModal] = useState(false);
  const [showReviewQuoteModal, setShowReviewQuoteModal] = useState(false);
  const [showEditQuoteModal, setShowEditQuoteModal] = useState(false);
  const [isOfferAccepting, setIsOfferAcdepting] = useState(false);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const { search } = window.location;
  const param = qs.parse(search);
  const navigate = useNavigate();
  const {
    refresh,
    setRefresh,
    activeTab,

  } = useContext(OrdersContext);
  const { setSelectedChatRefId, selectedChatRefId } = useContext(ChatRefContext);
  const [showRedirectModal, setShowRedirectModal] = useState(false);
  let userId = localStorage.getItem("_id");
  let email = localStorage.getItem("email");
  const [allData, setAllData] = useState([]);
  const [masterThreeDTechnologyData, setMasterThreeDTechnologyData] = useState([]);
  const [pdfModalInfo, setPdfModalInfo] = useState({
    show: false,
    fileName: '',
    pdfUrl: ''
  });
  useEffect(() => {
    (async () => {
      try {
        const data = await getAllTechnology();


        if (data?.success) {
          setMasterThreeDTechnologyData(data?.data);
        }

      } catch (error) {
        console.error(error);
      }
      finally {
      }
    })()

  }, []);
  useEffect(() => {
    (async () => {
      try {
        const data = await getAllMaterialsList();
        setAllData(data);


      } catch (error) {
        throw new Error("Unable To fetch All Material Data ");
      }

    })()

  }, []);


  useEffect(() => {
    let isLoggedInUser = validateUser(navigate);
    if (isLoggedInUser) {
      if (id) {
        setLoading(true);
        fetchData();
      }
    }
  }, []);
  const handleBatchDownloadClick = async () => {
    try {
      setLoading(true);
      const response = await downloadBatchFile(selectedRFQ?._id, 'supplier-rfq-offer');
      const blob = new Blob([response], { type: 'application/zip' });
      const downloadUrl = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `batch_download_${selectedRFQ?.type || ""}.zip`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(downloadUrl);



    } catch (error) {
      console.log("Error :", error);

      toast.error('Failed to download batch file at the moment');
    } finally {
      setLoading(false);
    }

  }

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await getRFQByRFQId(id, loggedInUserToken);
      if (
        response.data &&
        response.data.rfqOfferId?.partsData &&
        response.data.partsData
      ) {
        // Map unitPrice from rfqOfferId.partsData to outer partsData array
        response.data.partsData = response.data.partsData.map((part, index) => {
          const price = response.data.partsData[index]?.price || 0; // Fallback to 0 if unitPrice is missing
          return {
            ...part,
            price, // Add or overwrite the unitPrice
          };
        });
        setSelectedRFQ(response.data);
        if (
          response.data.status == "Cancelled" ||
          response.data.status == "Active Order"
        ) {
          setShowRedirectModal(true);
        }
      } else {
        toast.error(
          "Quotation data not found.Please contact us at admin to resolve the issue."
        );
        navigate("/my-orders");
        return;
      }

      let supplierLoggedIn = localStorage.getItem("supplierId");
      if (!supplierLoggedIn) {
        toast.error(
          "Something went wrong with loggedIn Credentials.Please login again."
        );
      } else {
        if (supplierLoggedIn != response.data.supplierId._id) {
          setIsValidUser(false);
        }
      }

      setLoading(false);
    } catch (err) {
      console.log("err", err);
      setLoading(false);
      toast.error("Something went wrong");
    }
  };


  const validateRFQData = () => {
    let isDataValid = true;
    let isPriceAvailable = false;

    for (let i = 0; i < selectedRFQ.partsData.length; i++) {
      if (selectedRFQ.partsData[i].unitPrice > 0) {
        isPriceAvailable = true;
        break;
      }
    }

    if (isPriceAvailable) {
      isDataValid = true;
    } else {
      isDataValid = false;
    }

    if (!selectedRFQ.leadTime) {
      isDataValid = false;
    }

    return isDataValid;
  };

  const handleAccepted = async () => {

    const userResponse = await new Promise((resolve) => {
      AntModal.confirm({
        title: 'Accept Offer',
        content: 'Are you sure you want to accept this offer?',
        okText: 'Yes',
        cancelText: 'No',
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      });
    });
    if (!userResponse) return;
    handleCreatePurchaseOrder(selectedRFQ);
  };

  const handleCreatePurchaseOrder = async (rfqSelectedForPO) => {
    setLoading(true);
    try {
      let formData = new FormData();
      formData.append("rfqData", JSON.stringify(rfqSelectedForPO));
      const poResponse = await createOfferAcceptedPO(
        formData,
        loggedInUserToken
      );
      if (poResponse?.data?.status) {
        toast.success(
          "Offer accepted successfully, a purchase order will be sent to you shortly"
        );
        // toast.success(poResponse?.data?.message);
        navigate(`/dashboard`);
      } else {
        toast.error(poResponse?.data?.message);
      }
    } catch (err) {
      console.log(
        "Error in 257 Offer Details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
    finally {
      setLoading(false);

    }
  };

  const handleDeclineClick = () => {
    setShowDeclineModal(true); // Show the modal
  };

  const handleDeclineModalClose = () => {
    setShowDeclineModal(false); // Close the modal
  };

  const handleSubmitQuotation = async () => {
    try {
      const rfqData = {
        supplierId: selectedRFQ.supplierId._id,
        createdBy: loggedInUserToken, // Assuming logged-in user's token is the creator
      };

      // API call to create RFQ
      const response = await createRFQ(rfqData);

      if (response?.status) {
        toast.success("RFQ created successfully!");
        // Optionally refresh or fetch new data
        // fetchNewValues();
      } else {
        toast.error(response.message || "Failed to create RFQ");
      }

      setShowDeclineModal(false); // Close modal after action
    } catch (error) {
      console.error("Error creating RFQ:", error);
      toast.error("An error occurred while creating the RFQ");
    }
  };

  const handleDeclineWithoutQuotation = async () => {
    try {
      setLoading(true);
      setShowDeclineModal(false);
      const id = selectedRFQ?._id;
      const response = await declineOffer(id, loggedInUserToken);
      if (response?.status) {
        toast.success("Offer declined ");
        setShowDeclineModal(false); // Close the modal
        navigate("/my-orders");
        // Additional logic can go here (e.g., refresh data)
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error("Error declining offer:", err);
      toast.error("Failed to decline offer.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitQuote = async () => {
    try {
      const supplierid = selectedRFQ._id;
      const isValidData = validateRFQData();

      // Create a new FormData object
      let formData = new FormData();

      // Append the necessary fields to the FormData object

      // Validate form data before submitting
      let response = await ReturnSubmitQuotations(
        selectedRFQ,
        supplierid,
        loggedInUserToken
      );

      if (response.status) {
        toast.success(response.message);

        // Navigate based on the active tab
        if (activeTab) {
          navigate(`/my-orders?status=${activeTab}`);
        } else {
          navigate(`/my-orders`);
        }

        // Refresh the data
        setRefresh(refresh + 1);
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.log("Error:", err);
      toast.error("An error occurred while submitting the quote.");
    }
  };

  const handleLeadTimeChange = (e) => {
    setSelectedRFQ({ ...selectedRFQ, leadTime: e.target.value });
  };

  const showDrawer = () => {
    console.log("Data ::", selectedRFQ.supplierRFQRefId);
    setSelectedChatRefId(selectedRFQ.supplierRFQRefId);
  };

  const onClose = () => {
    setSelectedChatRefId(null);
  };

  const handleUploadRFQDocument = async (e) => {
    try {
      let rfqOfferDocument = e.target.files[0];
      let formData = new FormData();
      formData.append("rfqOfferId", selectedRFQ._id);
      formData.append("rfqOfferDocument", rfqOfferDocument);

      const uploadRFQDocResponse = await uploadRFQDocument(
        loggedInUserToken,
        formData
      );
      if (uploadRFQDocResponse.status) {
        toast.success("Document uploaded");
        setSelectedRFQ({
          ...selectedRFQ,
          rfqOfferDocument: uploadRFQDocResponse?.data?.rfqOfferDocument,
        });
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const handleRFQDocumentDelete = async () => {
    try {
      const deleteDocResponse = await deleteRFQDocument(
        loggedInUserToken,
        selectedRFQ._id
      );
      if (deleteDocResponse.data.status) {
        setSelectedRFQ({ ...selectedRFQ, rfqOfferDocument: null });
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const RedirectComponent = () => {
    const [countdown, setCountdown] = useState(3);

    useEffect(() => {
      const timer = setTimeout(() => {
        navigate("/my-orders");
      }, countdown * 1000);

      return () => clearTimeout(timer);
    }, [countdown, navigate]);

    useEffect(() => {
      if (countdown > 0) {
        const countdownTimer = setInterval(() => {
          setCountdown((prevCountdown) => prevCountdown - 1);
        }, 1000);

        return () => clearInterval(countdownTimer);
      }
    }, [countdown]);

    return <div>Redirecting in {countdown} seconds...</div>;
  };

  const handleUnitPriceChange = (e, id) => {
    const { name, value } = e.target;

    // Update the partsData array
    const updatedPartsData = selectedRFQ.partsData.map((part) =>
      part._id === id
        ? {
          ...part,
          [name]:
            name === "price" || name === "qty"
              ? parseFloat(value) || 0
              : value,
        }
        : part
    );

    // Calculate the total price by summing up all unit prices
    const totalPrice = updatedPartsData.reduce(
      (sum, part) => sum + (part.price * part.qty || 0),
      0
    );
    // Update the state
    setSelectedRFQ((prev) => ({
      ...prev,
      partsData: updatedPartsData,
      price: totalPrice.toFixed(2), // Update the price in the state
    }));
    console.log(selectedRFQ);
  };
  console.log("offer data ::", selectedRFQ);

  return (
    <div className="content-wrapper">
      <Chat
        RefId={selectedRFQ.supplierRFQRefId}
        open={selectedChatRefId}
        onDrawerClose={onClose}
      />
      {selectedRFQ !== "Under Review" && (
        <Modal
          size="md"
          dialogClassName="quote-version-modal"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showDeclineModal}
          onHide={() => setShowDeclineModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title
              id="contained-modal-title-vcenter"
              className="text-2xl font-bold"
            >
              Submit Quotation?
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="text-lg">
              Do you wish to submit quotation for this offer?
            </p>
          </Modal.Body>
          <Modal.Footer>
            <button
              style={{
                color: "white",
                fontWeight: "500",
                backgroundColor: "#00c389",
              }}
              className="px-4 py-2 bg-blue-500 rounded text-white font-medium"
              onClick={() =>
                navigate(`/offer-edit/${selectedRFQ.supplierRFQRefId}`)
              } // Dynamic route navigation
            >
              Yes, Submit Quotation
            </button>
            <button
              style={{ color: "red", fontWeight: "500", marginRight: "0px" }}
              className="px-4 py-2 rounded font-medium white-btn border "
              onClick={handleDeclineWithoutQuotation}
            >
              Decline Offer
            </button>
          </Modal.Footer>
        </Modal>
      )}
      <PDFModalViewer
        show={pdfModalInfo.show}
        handleClose={() => setPdfModalInfo({ show: false, fileName: '', pdfUrl: '' })}
        fileName={pdfModalInfo.fileName}
        pdfUrl={pdfModalInfo.pdfUrl}
      />

      <Modal
        size="lg"
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        centered
        show={showReviewQuoteModal}
        onHide={() => setShowReviewQuoteModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={{ fontSize: "15px" }}
          >
            New Quotation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="version-tabs" style={{ overflowX: "auto" }}>
            <table className="qoute-version-table">
              <thead>
                <tr className="heading-row">
                  <th scope="col">File Name</th>
                  <th scope="col">Description</th>
                  {/* <th scope="col">Part Notes</th>
                  <th scope="col">Notes</th> */}
                  <th scope="col">Unit Price</th>
                  <th scope="col">Qty</th>
                  <th scope="col">Amount</th>
                </tr>
              </thead>
              <tbody>
                {selectedRFQ?.partsData?.length > 0 &&
                  selectedRFQ.partsData.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td className="min-w-max border">
                          <div
                            className="prd-thumb downloadables"
                            style={{ color: "dodgerblue" }}
                          >
                            <p
                              style={{ color: "dodgerblue" }}
                              className="flex justify-start gap-x-2 "
                            >
                              <span className="min-w-max">
                                {item.selectedFile
                                  ? item?.selectedFile?.originalname
                                  : "File Not Available"}
                              </span>

                              {item.selectedFile?.originalname && (
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={async (e) => {
                                    const { originalname } = item.selectedFile;
                                    if (originalname && originalname.endsWith('.pdf')) {
                                      const signedUrl = await getPresignedUrlForFile(item.selectedFile.bucket, item.selectedFile.key);
                                      console.log('Signed URL for PDF:', signedUrl);
                                      setPdfModalInfo({
                                        show: true,
                                        pdfUrl: signedUrl,
                                        fileName: originalname,
                                      })
                                      return;
                                    }
                                    await downloadFileFromS3(item.selectedFile);
                                  }}
                                >
                                  <DownloadIcon />
                                </span>
                              )}
                            </p>
                          </div>
                        </td>
                        <td style={{ width: "240px" }}>
                          {selectedRFQ?.rfqOfferId?.selectedProcess >= 3 ? (
                            <>{item.description}</>
                          ) : (
                            <>
                              <ul>
                                {item?.description}
                                {item?.materialType ? (
                                  <li>{item?.materialType}</li>
                                ) : (
                                  ""
                                )}
                                {item?.subMaterial ? (
                                  <li>{item?.subMaterial}</li>
                                ) : (
                                  ""
                                )}
                                {item?.surfaceFinish ? (
                                  <li>{item?.surfaceFinish}</li>
                                ) : (
                                  ""
                                )}
                                {item?.surfaceTreatment ? (
                                  <li>{item?.surfaceTreatment}</li>
                                ) : (
                                  ""
                                )}
                                {item?.tolerance ? (
                                  <li>{item?.tolerance}</li>
                                ) : (
                                  ""
                                )}
                                {item?.partMarking ? (
                                  <li>{item?.partMarking}</li>
                                ) : (
                                  ""
                                )}
                                {item?.noOfThread ? (
                                  <li>{item?.noOfThread}</li>
                                ) : (
                                  ""
                                )}
                              </ul>
                            </>
                          )}
                        </td>
                        <td>
                          <p>
                            {showEditQuoteModal ? (
                              <div className="flex items-center">
                                <input
                                  style={{ width: "100px" }}
                                  type="text"
                                  className="border px-2 py-1"
                                  name="price"
                                  value={item.price}
                                  onChange={(e) =>
                                    handleUnitPriceChange(e, item._id)
                                  }
                                />
                              </div>
                            ) : (
                              <CurrencyFormat
                                amount={Number(item.price).toFixed(2)}
                              />
                            )}
                          </p>
                        </td>
                        <td>
                          <p className="amt">
                            {showEditQuoteModal ? (
                              <div className="flex items-center">
                                <input
                                  style={{ width: "100px" }}
                                  type="text"
                                  className="border px-2 py-1"
                                  name="qty"
                                  value={item?.qty}
                                  onChange={(e) =>
                                    handleUnitPriceChange(e, item._id)
                                  }
                                />
                              </div>
                            ) : (
                              item?.qty
                            )}
                          </p>
                        </td>
                        <td>
                          <div className="amt">
                            <p className="un-fld">
                              <CurrencyFormat
                                amount={Number(item.qty * item.price).toFixed(
                                  2
                                )}
                              />
                            </p>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            <div
              style={{ display: "flex", justifyContent: "space-between" }}
              className="border "
            >
              <div
                className="total-amount-order"
                style={{ padding: "10px 10px" }}
              >
                <h6 className="order-price">
                  Lead Time (in Days) :{selectedRFQ.leadTime + " days"}
                </h6>
              </div>
              <div
                className="total-amount-order"
                style={{ padding: "10px 10px" }}
              >
                <h6 className="order-price">
                  Total:{" "}
                  {showEditQuoteModal ? (
                    <CurrencyFormat
                      amount={Number(selectedRFQ.price).toFixed(2)}
                    />
                  ) : (
                    <CurrencyFormat
                      amount={Number(selectedRFQ.offerPrice).toFixed(2)}
                    />
                  )}
                </h6>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="white-btn"
            style={{ color: "red", fontWeight: "500" }}
            onClick={() => setShowEditQuoteModal(true)}
          >
            Edit
          </button>
          <button
            className="white-btn"
            style={{ backgroundColor: "#2b96dc", color: "#fff" }}
            onClick={handleSubmitQuote}
          >
            Submit Quotation
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        size="lg"
        dialogClassName="qoute-version-modal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showRedirectModal}
        onHide={() => {
          navigate(`/my-orders`);
          setShowRedirectModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={{ fontSize: "15px" }}
          >
            Quotation is already processed.
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div>
              <h6>Quotation for this reference Id is already processed.</h6>
              <RedirectComponent />
            </div>
            <br />
          </div>
          <div style={{ color: "#8b8b8b" }}></div>
        </Modal.Body>
      </Modal>

      {isValidUser && !loading ? (
        <>
          <div className="intro-bar-rfq">
            <div className="int-left-rfq">
              <div
                className="left-item"
                style={{ marginRight: "40px", cursor: "pointer" }}
                onClick={() => navigate(-1)}
              >
                <img src={backImg} height="15px" />
              </div>

              <div className="left-item">
                <p className="p-header">
                  Offer ID : {selectedRFQ.supplierRFQRefId}
                </p>
                <p
                  className={
                    selectedRFQ.status === "Pending for Quotation"
                      ? "pending-for-quotation"
                      : selectedRFQ.status === "Under Review"
                        ? "under-review"
                        : selectedRFQ.status === "Unapproved"
                          ? "unapproved-quotes"
                          : selectedRFQ.status === "Offer Pending Acceptance"
                            ? "offer-pending-for-quotation !px-5"
                            : ""
                  }
                >
                  {selectedRFQ.status}
                </p>

              </div>

              <div className="left-item">
                <p className="p-header">REQUESTED DATE</p>
                <p>{moment(selectedRFQ.receivedDate).format("DD MMM YYYY")}</p>
              </div>
            </div>

          </div>

          <div className="dashboard-holder ">
            <div className="lg-container -translate-y-10">
              {/* <Chat RefId={RefId} open={open} onDrawerClose={onClose} /> */}
              <div className="common-bx">
                <div
                  className={
                    selectedRFQ.status == "Under Review"
                      ? "process-bar-bx green-line"
                      : "process-bar-bx grey-line"
                  }
                >
                  <span className="process-ico green-fill">
                    <img src={settingw} />
                  </span>
                  <div
                    style={{
                      maxWidth: "500px",
                      wordWrap: "break-word",
                      wordBreak: "break-all",
                      whiteSpace: "normal",
                      position: "absolute",
                      right: "150px",
                    }}
                  >
                    <span
                      className="text"
                      style={{
                        color: "#000",
                        fontSize: "14px",
                        fontWeight: "bolder",
                      }}
                    >
                      Project Name
                    </span>
                    <div
                      className="name"
                      style={{ color: "#000", fontSize: "14px" }}
                    >
                      {selectedRFQ?.rfqOfferId?.projectName || "Not Found"}
                    </div>
                  </div>
                  <h5>Requirements</h5>
                  <p style={{ color: "#333333", fontSize: "12px" }}>
                    {moment(selectedRFQ.createdAt).format("DD MMM YYYY")}
                  </p>
                  <div className="flex items-center justify-between">
                    <h6
                      className="box-in-quote-version"
                      style={{ color: "#333333" }}
                    >
                      MFG. Process :{" "}
                      {selectedRFQ?.rfqOfferId?.selectedProcess
                        ? processType[selectedRFQ?.rfqOfferId?.selectedProcess - 1]
                          .name
                        : null}
                    </h6>
                    <div className="flex items-center justify-end">
                      <button onClick={handleBatchDownloadClick} className="rounded px-3 py-2 border flex items-center justify-center gap-x-2 " >
                        <span>Batch download all technical drawings</span>
                        <DownloadIcon />
                      </button>
                    </div>

                  </div>
                  <div className="version-tabs overflow-x-auto" >
                    <table className="qoute-version-table">
                      <thead>
                        <tr className="heading-row " >
                          <th scope="col">Snapshot</th>
                          <th scope="col" >Files</th>
                          <th scope="col" >Description</th>
                          <th scope="col" >Notes</th>
                          <th scope="col" >Unit Price</th>
                          <th scope="col" >Qty</th>
                          <th scope="col" >Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedRFQ?.partsData?.length > 0 &&
                          selectedRFQ.partsData.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td style={{ minWidth: "150px" }} className=" ">
                                  <p className="text-sm bold h-28  ">
                                    <ThreeDViewerComponent
                                      item={item}
                                      selectedProcess={selectedRFQ?.rfqOfferId?.selectedProcess}
                                      additionalClasses={'!border-0'}
                                    />
                                  </p>
                                </td>
                                <td
                                  style={{ minWidth: "250px" }}
                                  className=" "
                                >
                                  <div
                                    className="prd-thumb downloadables !text-primaryColor"
                                  >
                                    {item.selectedFile?.originalname ? (
                                      <FileName
                                        fileName={item.selectedFile?.originalname}
                                        onDownload={async () => {
                                          const { originalname } = item.selectedFile;
                                          if (originalname && originalname.endsWith('.pdf')) {
                                            const signedUrl = await getPresignedUrlForFile(item.selectedFile.bucket, item.selectedFile.key);
                                            console.log('Signed URL for PDF:', signedUrl);
                                            setPdfModalInfo({
                                              show: true,
                                              pdfUrl: signedUrl,
                                              fileName: originalname,
                                            })
                                            return;
                                          }
                                          await downloadFileFromS3(item.selectedFile);
                                        }}
                                      />
                                    ) : (
                                      "File Not Available"
                                    )}
                                  </div>
                                  <div
                                    className="prd-thumb downloadables !text-primaryColor"
                                  >
                                    {item.twoDFile?.originalname ? (
                                      <FileName
                                        fileName={item.twoDFile?.originalname}
                                        onDownload={async () => {
                                          const { originalname } = item.twoDFile;
                                          if (originalname && originalname.endsWith('.pdf')) {
                                            const signedUrl = await getPresignedUrlForFile(item.twoDFile.bucket, item.twoDFile.key);
                                            console.log('Signed URL for PDF:', signedUrl);
                                            setPdfModalInfo({
                                              show: true,
                                              pdfUrl: signedUrl,
                                              fileName: originalname,
                                            })
                                            return;
                                          }
                                          await downloadFileFromS3(item.twoDFile);
                                        }}
                                      />

                                    ) : (
                                      "File Not Available"
                                    )}
                                  </div>
                                </td>
                                <td style={{ minWidth: "270px" }}>
                                  {selectedRFQ?.rfqOfferId?.selectedProcess >= 3 ? (
                                    <>{item.description}</>
                                  ) : (
                                    <div>
                                      {
                                        selectedRFQ?.rfqOfferId?.selectedProcess == 1 ?
                                          <MetaDataCncComponent allData={allData} item={item} /> : null

                                      }
                                      {
                                        selectedRFQ?.rfqOfferId?.selectedProcess == 2 ?
                                          <MetaDataThreeDComponent masterThreeDTechnologyData={masterThreeDTechnologyData} item={item} /> : null

                                      }

                                    </div>
                                  )}
                                </td>
                                {/* <td>
                                  <p>{item?.partNotes}</p>
                                </td> */}
                                <td style={{ minWidth: "200px" }}>
                                  <p>{item?.notes}</p>
                                </td>
                                <td style={{ minWidth: "100px" }}>
                                  <div className="flex justify-center gap-x-2">
                                    <p>
                                      {item.price ? <CurrencyFormat
                                        amount={parseFloat(item.price)}

                                      /> : "0.00"}
                                    </p>
                                  </div>
                                </td>
                                <td style={{ minWidth: "70px" }}>
                                  <p className="amt text-center">{item?.qty}</p>
                                </td>
                                <td style={{ minWidth: "100px" }}>
                                  <div className="amt flex justify-center gap-x-2">
                                    <p className="un-fld">
                                      <CurrencyFormat
                                        amount={Number(
                                          item.qty * item.price
                                        ).toFixed(2)}
                                      />
                                    </p>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  <div className="mt-3  flex justify-end ">

                    <div>
                      <div className="flex items-center gap-x-2 justify-center ">
                        <div className="grow">
                          <p
                            style={{
                              color: "#333333",
                              fontSize: "14px",
                              fontWeight: "500",
                            }}
                          >
                            Lead Time (in Days):
                          </p>
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              marginTop: "-10px",
                            }}
                          >
                            <div
                              className="apply-check"
                              style={{ marginRight: "80px" }}
                            >
                              <input
                                className="border p-1"
                                type="number"
                                style={{ fontSize: "13px" }}
                                onWheel={numberInputOnWheelPreventChange}
                                onKeyDown={(e) =>
                                  ["e", "E", "+", "-"].includes(e.key) &&
                                  e.preventDefault()
                                }
                                onChange={handleLeadTimeChange}
                                disabled={
                                  selectedRFQ.status == "Pending for Quotation"
                                    ? false
                                    : true
                                }
                                placeholder="Lead time in Days"
                                value={
                                  selectedRFQ.leadTime
                                    ? selectedRFQ.leadTime
                                    : ""
                                }
                              />
                              {selectedRFQ.leadTime ? (
                                <div style={{ fontSize: "13px" }}>
                                  ({selectedRFQ.leadTime + " Business Days"})
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="total-amount-order  grow w-[180px]  ">
                          <h6 className="order-price h-10 ">
                            <div> Total : </div>
                            <div className="mt-2">
                              {/*  */}
                              {selectedRFQ.offerPrice ? (
                                <CurrencyFormat
                                  amount={Number(
                                    selectedRFQ.offerPrice
                                  ).toFixed(2)}
                                />
                              ) : (
                                "0"
                              )}
                            </div>
                          </h6>
                        </div>
                      </div>
                      <div>
                        {selectedRFQ.status == "Pending for Quotation" && (
                          <div>
                            <button
                              className=" px-3 py-2 mt-4  float-end rounded flex justify-center items-center"
                              style={{
                                color: "white",
                                fontWeight: "500",
                                backgroundColor: "#00c389",
                                width: "100%",
                              }}
                              onClick={() => {
                                const isValidData = validateRFQData();
                                if (isValidData) {
                                  setShowReviewQuoteModal(true);
                                } else {
                                  toast.error(
                                    "Item price and delivery date are required field."
                                  );
                                }
                              }}
                            >
                              Submit Quotation
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="order-pay-box">
                  <span className="order-ico">
                    <img src={docGrey} />
                  </span>
                  <h5>Order Details</h5>
                  {selectedRFQ.status == "Under Review" ? (
                    <div
                      style={{
                        background: "#DEE2E6",
                        padding: "20px 30px",
                        borderRadius: "5px",
                        fontSize: "14px",
                      }}
                    >
                      <h6>Your quote is under review.</h6>
                      <p>
                        Your quotation has been submitted successfully. If your
                        quote is accepted, we will send you a Purchase Order
                      </p>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
                <div className="d-flex justify-content-end gap-2">
                  {selectedRFQ?.rfqOfferId?.rfqOfferStatus === "offer accepted" ? (
                    <p className="fs-6 fw-bolder" style={{ color: "#00c389" }}></p>
                  ) : selectedRFQ?.rfqOfferId?.rfqOfferStatus === "cancelled-offer" ? (
                    <p className="fs-6 fw-bolder" style={{ color: "red" }}>

                    </p>
                  ) : (
                    <>
                      {!isOfferAccepting ? <button
                        onClick={handleAccepted}
                        style={{
                          color: "white",
                          fontWeight: "500",
                          backgroundColor: "#00c389",
                        }}
                        className={`px-3 py-0 mt-4  float-end rounded flex justify-center items-center ${selectedRFQ.status === "Unapproved"
                          ? "bg-gray-400 cursor-not-allowed"
                          : "bg-primaryColor"
                          }`}
                        disabled={selectedRFQ.status === "Unapproved"}
                      >
                        Accept Offer
                      </button> : <button
                        onClick={handleAccepted}
                        style={{
                          color: "white",
                          fontWeight: "500",
                          backgroundColor: "#00c389",
                        }}
                        className={`px-3 py-0 mt-4  float-end rounded flex justify-center items-center`}
                      >
                        <LucidLoader />
                      </button>}
                      <button
                        style={{
                          color: "white",
                          fontWeight: "500",
                          backgroundColor: "#00c389",
                        }}
                        className={`px-3 py-0 mt-4  float-end rounded flex justify-center items-center ${"bg-primaryColor"}`}
                        onClick={showDrawer}
                      >
                        <ChatButton
                          color={"white"}
                          RefId={selectedRFQ.supplierRFQRefId}
                          showDrawer={showDrawer}
                          additionalClasses={"text-white text-sm"}
                        />
                      </button>
                      <button
                        onClick={
                          selectedRFQ.status === "Unapproved"
                            ? undefined
                            : () => setShowDeclineModal(true)
                        }
                        style={{
                          color: "white",
                          fontWeight: "500",
                          backgroundColor: "#00c389",
                        }}
                        className={`px-3 py-0 mt-4  float-end rounded flex justify-center items-center ${selectedRFQ.status === "Unapproved"
                          ? "bg-gray-400 cursor-not-allowed"
                          : "bg-primaryColor"
                          }`}
                        disabled={selectedRFQ.status === "Unapproved"}
                      >
                        Decline Offer
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : loading ? (
        <>
          <Loading />
        </>
      ) : (
        <>
          <div className="dashboard-holder">
            <div className="sm-container">
              <div className="dashboard-option">
                <div className="dash-left">
                  <div className="ds-heading">
                    <Link to="/dashboard">
                      <p className="req-quote-btn">Go To DashBoard </p>
                    </Link>
                  </div>
                </div>

                <div style={{ textAlign: "center" }}>
                  <h2>Quotation information is not available</h2>
                  <br />
                  <p>Your dont have access to this quote version details.</p>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default OfferDetails;
